<svg width="390" height="844" viewBox="0 0 390 844" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_236_36544)">
<rect width="390" height="844" fill="#5BC4FF"/>
<path d="M386.61 0C388.482 1.6158e-07 390 1.5177 390 3.38965V435.513C316.598 348.049 251.416 253.177 194.352 151C137.661 252.592 72.9003 346.963 0 434.011V3.38965C1.65749e-07 1.5177 1.5177 -1.6158e-07 3.38965 0H386.61Z" fill="#38443F"/>
</g>
<defs>
<clipPath id="clip0_236_36544">
<rect width="390" height="844" fill="white"/>
</clipPath>
</defs>
</svg>
